import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1" }

import { useFiltersStore } from '@/js/productDatabase/stores/filters';

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductSort',
  setup(__props) {

const filtersStore = useFiltersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        class: "col-start-1 row-start-1 w-full appearance-none rounded bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-teal focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filtersStore).order) = $event))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("option", {
          value: null,
          disabled: ""
        }, "Sortering", -1),
        _createElementVNode("option", { value: "usableArea ASC" }, "Minst til størst", -1),
        _createElementVNode("option", { value: "postDate DESC" }, "Nyeste først", -1)
      ]), 512), [
        [_vModelSelect, _unref(filtersStore).order]
      ])
    ])
  ]))
}
}

})